import { render } from "./Promo1.vue?vue&type=template&id=3f5f39f9"
import script from "./Promo1.vue?vue&type=script&lang=js"
export * from "./Promo1.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__